import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden py-10"
      style={{
        background:
          "linear-gradient(135deg, rgba(8,43,87,0.95) 0%, rgba(8,43,87,0.7) 100%), url('assets/images/hero-bg.png')",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] border border-white/20 rounded-full" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] border border-white/10 rounded-full" />
      </div>

      {/* Glowing Accents */}
      <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-[#F59E0B]/5 rounded-full blur-[130px] pointer-events-none" />
      <div className="absolute top-1/3 right-1/4 w-[300px] h-[300px] bg-sky-500/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <motion.span
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="inline-block bg-[#F59E0B]/20 text-[#F59E0B] px-4 py-2 rounded-full text-sm font-medium mb-6"
            >
              Trusted Construction Company in Indore
            </motion.span>

            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight heading-font"
            >
              Building
              <span className="block text-[#F59E0B]">
                Dreams Into
              </span>
              Reality
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="text-white/80 text-lg mt-6 max-w-xl leading-8"
            >
              AZ Construction provides professional construction,
              property development, property dealer and liaisoning
              services with a commitment to quality, transparency,
              and customer satisfaction.
            </motion.p>

            {/* Buttons */}

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="mt-10 flex flex-col sm:flex-row gap-4"
            >
              <Link
                to="/contact-us"
                className="bg-[#F59E0B] hover:bg-orange-600 transition px-8 py-4 rounded-xl text-white font-semibold flex items-center justify-center"
              >
                Get Consultation
              </Link>

              <Link
                to="/services"
                className="border border-white text-white hover:bg-white hover:text-[#082B57] transition px-8 py-4 rounded-xl font-semibold flex items-center justify-center"
              >
                Our Services
              </Link>
            </motion.div>

            {/* Stats */}

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
              className="grid grid-cols-3 gap-2 sm:gap-6 mt-14 text-center"
            >

              <div>
                <h3 className="text-[#F59E0B] xl:text-3xl  text-xl font-bold">
                  <CountUp end={500} duration={3} />+
                </h3>
                <p className="text-white/70 xl:text-sm text-xs mt-1">
                  Projects Completed
                </p>
              </div>

              <div>
                <h3 className="text-[#F59E0B] xl:text-3xl  text-xl font-bold">
                  <CountUp end={1000} duration={3} />+
                </h3>
                <p className="text-white/70 xl:text-sm text-xs mt-1">
                  Happy Clients
                </p>
              </div>

              <div>
                <h3 className="text-[#F59E0B] xl:text-3xl  text-xl font-bold">
                  <CountUp end={10} duration={3} />+
                </h3>
                <p className="text-white/70 xl:text-sm text-xs mt-1">
                  Years Experience
                </p>
              </div>

            </motion.div>

          </div>

          {/* Right Image */}

          <motion.div
            initial={{ opacity: 0, x: 70 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="hidden lg:flex justify-end"
          >
            <div className="relative group/hero-img">
              {/* Image Glow */}
              <div className="absolute inset-0 bg-[#F59E0B]/10 rounded-3xl blur-2xl opacity-0 group-hover/hero-img:opacity-100 transition duration-500 -z-10" />

              <img
                src="assets/images/hero-bg.png"
                alt="Construction"
                className="max-w-full rounded-3xl shadow-2xl border border-white/10 group-hover/hero-img:scale-[1.01] transition duration-500"
              />

              {/* Floating Card 1 */}

              <motion.div
                animate={{
                  y: [0, -12, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                className="absolute -left-10 top-12 bg-white/95 backdrop-blur-md p-5 rounded-2xl shadow-2xl border border-white/20 cursor-default"
              >
                <h4 className="text-[#082B57] font-bold text-2xl">
                  500+
                </h4>
                <p className="text-gray-500 text-sm font-medium">
                  Projects Delivered
                </p>
              </motion.div>

              {/* Floating Card 2 */}

              <motion.div
                animate={{
                  y: [0, 12, 0],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                className="absolute -right-10 bottom-12 bg-[#F59E0B]/95 backdrop-blur-md p-5 rounded-2xl shadow-2xl border border-[#F59E0B]/20 cursor-default text-white"
              >
                <h4 className="font-bold text-2xl">
                  100%
                </h4>
                <p className="text-white/90 text-sm font-medium">
                  Client Satisfaction
                </p>
              </motion.div>

            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;